define.alias("shared/components/shared/ember-drop-multi-select-item", "calendar/components/shared/ember-drop-multi-select-item");